var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "dl",
    {
      staticClass: "clearfix bg-blue-box p15 mt15",
      class: { "is-open": _vm.isOpen },
    },
    [
      _c(
        "job-preview-right-column",
        _vm._g(
          {
            attrs: {
              "text-count-mode": _vm.textCountMode,
              "highlight-mode": _vm.highlightMode,
              "comment-class": "sub",
              "comment-highlights": _vm.commentHighlights,
            },
          },
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _vm.isBulkRegistrationAddress
        ? [
            _c("dt", [_vm._v("【" + _vm._s(_vm.title) + "】")]),
            _vm._v(" "),
            _c("dd", {
              staticClass: "pega-pre-wrap",
              attrs: {
                id: _vm.placeId,
                "data-test": "requirements-combined-all-bulk-place",
              },
              domProps: { textContent: _vm._s(_vm.value) },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.isBulkRegistrationAddress
        ? [
            _c("dt", [_vm._v("【" + _vm._s(_vm.title) + "】")]),
            _vm._v(" "),
            _c("dd", {
              staticClass: "clearfix",
              class: { shorten: _vm.showToggleButton && !_vm.isOpen },
              attrs: {
                id: _vm.placeId,
                "data-test": "requirements-work-location",
              },
              domProps: { textContent: _vm._s(_vm.value) },
            }),
            _vm._v(" "),
            _vm.showToggleButton
              ? _c(
                  "div",
                  {
                    staticClass: "job-location-accordion",
                    attrs: { "data-test": "toggle" },
                  },
                  [
                    _c("p", { on: { click: _vm.togglePlaceText } }, [
                      _vm._v(
                        "\n        " + _vm._s(_vm.buttonText) + "\n      "
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }